import { Text } from '@dixa/lib-shared-habla';

import { ConversationAuditLogEntry } from 'apis/auditLogs';

import { getLogEntryAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

type ConversationOfferResponseProps = {
  entry: ConversationAuditLogEntry<
    'CONVERSATION_OFFER_ACCEPTED' | 'CONVERSATION_OFFER_REJECTED'
  >;
};

// Error codes published by offer-service (com.dixa.offer.entitity.ErrorCode).
// Anything unknown falls back to a bare "(failed)".
const failureReasons: Record<string, string> = {
  AgentWorkloadLimitReached: 'agent was busy',
  ConversationAlreadyAssigned: 'conversation was already assigned',
  NotAssignableState: 'conversation could not be assigned in its state',
  OngoingOfferNotFound: 'offer was no longer available',
  Upstream: 'upstream error',
  UnsuccessfulConversationAssignment: 'assignment failed',
};

export const ConversationOfferResponse = ({
  entry,
}: ConversationOfferResponseProps): JSX.Element => {
  const authorName = getLogEntryAuthorName(entry);
  const authorLink = authorName ? (
    <UserLink userId={entry.author.id}>{authorName}</UserLink>
  ) : null;

  const action =
    entry.activity_type === 'CONVERSATION_OFFER_ACCEPTED'
      ? 'accepted'
      : 'rejected';

  const reason = entry.failed_message
    ? failureReasons[entry.failed_message]
    : undefined;

  const failure = entry.failed_message
    ? ` failed${reason ? ` - ${reason}` : ''}`
    : '';

  const text = entry.failed_message ? (
    <Text.Input variant="error">
      Conversation {action} {failure}
    </Text.Input>
  ) : (
    <>
      Conversation is {action} {authorLink && <>by {authorLink}</>}
    </>
  );

  return <LogEntry entry={entry} text={text} />;
};
